import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { unescape } from 'underscore';

import { RESERVE_BID_LABEL } from 'components/constants';
import { selectAdminBidderApprovalIds } from 'redux/slices/auction-info/selectors';
import { selectDisplayMessages } from 'redux/slices/broker/selectors';

import { BID_ACCEPT_MESSAGE_BIDDER_DETAILS_REGEX } from './constants';

import styles from './live-messages.module.scss';

export function LiveMessages() {
  const displayMessages = useSelector(selectDisplayMessages);
  const adminBidderApprovalIds = useSelector(selectAdminBidderApprovalIds);

  return (
    <div className={styles['live-message']}>
      {displayMessages?.map(({ id, message, isAlert, acceptedApprovalId }, index: number) => {
        // An accepted reserve bid shows the reserve bid label in place of the bidder details
        const isReserveBid = !!acceptedApprovalId && adminBidderApprovalIds.includes(acceptedApprovalId);

        return (
          <span key={`${index}-${id}`} className={classNames({ [styles['ask-error-message']]: isAlert })}>
            {unescape(isReserveBid ? message.replace(BID_ACCEPT_MESSAGE_BIDDER_DETAILS_REGEX, '') : message)}
            {isReserveBid && <span className={styles['reserve-bid']}> ({RESERVE_BID_LABEL})</span>}
          </span>
        );
      })}
    </div>
  );
}
